export const incomedata = [
  {
    id: "1",
    Date: "01 Jan 2024",
    IncomeCategory: "Printing",
    img: "assets/img/users/user-01.jpg",
    User: "Mitchum Daniel",
    PaymentMethod: "assets/img/icons/pay.svg",
    Amount: "$21,144",
  },
  {
    id: "2",
    Date: "14 Jan 2024",
    IncomeCategory: "Utilities",
    img: "assets/img/users/user-02.jpg",
    User: "Susan Lopez",
    PaymentMethod: "assets/img/icons/stripe.svg",
    Amount: "$17,477",
  },
  {
    id: "3",
    Date: "25 Jan 2024",
    IncomeCategory: "Travel",
    img: "assets/img/users/user-03.jpg",
    User: "Robert Grossman",
    PaymentMethod: "assets/img/icons/stripe.svg",
    Amount: "$22,744",
  },
  {
    id: "4",
    Date: "01 May 2024",
    IncomeCategory: "Purchase",
    img: "assets/img/users/user-04.jpg",
    User: "Russell Belle",
    PaymentMethod: "assets/img/icons/stripe.svg",
    Amount: "$20,474",
  },
  {
    id: "5",
    Date: "14 Oct 2024",
    IncomeCategory: "Printing",
    img: "assets/img/users/user-05.jpg",
    User: "Edward K. Muniz",
    PaymentMethod: "assets/img/icons/pay.svg",

    Amount: "$14,174",
  },
];
